import { render, staticRenderFns } from "./lkuAp.vue?vue&type=template&id=48fe2a4d"
import script from "./lkuAp.vue?vue&type=script&lang=js"
export * from "./lkuAp.vue?vue&type=script&lang=js"
import style0 from "./lkuAp.vue?vue&type=style&index=0&id=48fe2a4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports